var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("div", { staticClass: "campaigns-form", attrs: { id: "details" } }, [
        _vm._m(0),
        _vm._m(1),
        _c("div", { staticClass: "grid" }, [
          _c(
            "div",
            { staticClass: "col-8_md-6_sm-12" },
            [
              _c(
                "router-link",
                {
                  staticClass: "campaigns-form__bliss",
                  attrs: { to: { name: "home" }, "active-class": "" }
                },
                [_c("i", { staticClass: "icon-bliss" })]
              ),
              _c("div", { staticClass: "campaigns-form__reel" }, [
                _c("div", { staticClass: "campaigns-form__reel__line" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.campaign.title) +
                      "\n            "
                  ),
                  _c("div", { staticClass: "underline" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.campaign.titleUnderline) +
                        "\n            "
                    )
                  ])
                ])
              ]),
              _c(
                "div",
                { staticClass: "campaigns-form__video" },
                [
                  _c("icon-play-view", {
                    attrs: {
                      loading: _vm.loadingVideo,
                      immediate: true,
                      invert: true
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.clickFullscreen.apply(null, arguments)
                      }
                    }
                  }),
                  _c("video-fullscreen-view", {
                    attrs: {
                      "video-id": _vm.videoId,
                      fullscreen: _vm.fullscreen
                    },
                    on: {
                      "close-fullscreen": function($event) {
                        _vm.fullscreen = false
                      },
                      "click-esc": function($event) {
                        _vm.fullscreen = false
                      },
                      "stop-loading": function($event) {
                        _vm.loadingVideo = false
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "campaigns-form__phone" },
                [
                  _c("icon-phone-view", [
                    _c(
                      "a",
                      { attrs: { href: _vm.getPhone(_vm.campaign.phone) } },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.campaign.phone) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "col-4_md-6_sm-12" }, [
            _c("div", { staticClass: "on-desktop" }, [
              _c("div", { staticClass: "campaigns-form__title" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("project_8")) +
                    "\n          "
                )
              ]),
              _c("div", { staticClass: "campaigns-form__subtitle" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("project_9")) +
                    "\n          "
                )
              ]),
              _c(
                "form",
                {
                  staticClass: "grid",
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.submitContact.apply(null, arguments)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("input-label-view", {
                        attrs: { label: "contact_5" },
                        model: {
                          value: _vm.name,
                          callback: function($$v) {
                            _vm.name = $$v
                          },
                          expression: "name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("input-label-view", {
                        attrs: { type: "email", label: "contact_6" },
                        model: {
                          value: _vm.email,
                          callback: function($$v) {
                            _vm.email = $$v
                          },
                          expression: "email"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("input-label-view", {
                        attrs: { type: "tel", label: "contact_7" },
                        model: {
                          value: _vm.phone,
                          callback: function($$v) {
                            _vm.phone = $$v
                          },
                          expression: "phone"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("input-text-view", {
                        attrs: { label: "contact_8" },
                        model: {
                          value: _vm.message,
                          callback: function($$v) {
                            _vm.message = $$v
                          },
                          expression: "message"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "button-view",
                    { attrs: { type: "submit", variant: "full special" } },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.campaign.button) +
                          "\n            "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _c("div", { staticClass: "campaigns-form__fields on-phone" }, [
        _c("div", { staticClass: "campaigns-form__title" }, [
          _vm._v("\n      " + _vm._s(_vm.$t("project_8")) + "\n    ")
        ]),
        _c("div", { staticClass: "campaigns-form__subtitle" }, [
          _vm._v("\n      " + _vm._s(_vm.$t("project_9")) + "\n    ")
        ]),
        _c(
          "form",
          {
            staticClass: "grid",
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.submitContact.apply(null, arguments)
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("input-label-view", {
                  attrs: { label: "contact_5" },
                  model: {
                    value: _vm.name,
                    callback: function($$v) {
                      _vm.name = $$v
                    },
                    expression: "name"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("input-label-view", {
                  attrs: { type: "email", label: "contact_6" },
                  model: {
                    value: _vm.email,
                    callback: function($$v) {
                      _vm.email = $$v
                    },
                    expression: "email"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("input-label-view", {
                  attrs: { type: "tel", label: "contact_7" },
                  model: {
                    value: _vm.phone,
                    callback: function($$v) {
                      _vm.phone = $$v
                    },
                    expression: "phone"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("input-text-view", {
                  attrs: { label: "contact_8" },
                  model: {
                    value: _vm.message,
                    callback: function($$v) {
                      _vm.message = $$v
                    },
                    expression: "message"
                  }
                })
              ],
              1
            ),
            _c(
              "button-view",
              { attrs: { type: "submit", variant: "full special" } },
              [_vm._v("\n        " + _vm._s(_vm.campaign.button) + "\n      ")]
            )
          ],
          1
        )
      ]),
      _c(
        "message-view",
        { attrs: { show: _vm.show } },
        [
          _c("template", { slot: "title" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("message_3")) + "\n    ")
          ]),
          _c("template", { slot: "message" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("message_4")) + "\n    ")
          ]),
          _c(
            "template",
            { slot: "action" },
            [
              _c(
                "button-view",
                {
                  attrs: { type: "submit", variant: "center title" },
                  nativeOn: {
                    click: function($event) {
                      _vm.show = false
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("message_6")) + "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", { staticClass: "campaigns-form__image" }, [
      _c("picture", [
        _c("source", {
          attrs: {
            media: "--large",
            "data-srcset":
              "/static/images/banner.jpg,\n          /static/images/banner@2x.jpg 2x, /static/images/banner@3x.jpg 3x"
          }
        }),
        _c("img", {
          staticClass: "lazyload",
          attrs: {
            "data-sizes": "auto",
            "data-src": "/static/images/banner.jpg"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "campaigns-form__icon" }, [
      _c("i", { staticClass: "icon-arrow animation-jump" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d97898d0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d97898d0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaigns/campaigns-form-view.vue
// module id = 605
// module chunks = 43